<template>
  <div class="content-title content-mb-14 uf_name">
    {{ text }}
    <VDropdown trigger="click" placement="bottom" popperClass="custom-popper">
      <a class="info-holder-icon" />
      <template #popper>
        <span class="custom-popper-content" v-html="helpText"></span>
      </template>
    </VDropdown>
  </div>
</template>

<script>
import { Dropdown as VDropdown } from "floating-vue";

export default {
  name: "HelpFiledStep2",
  components: {
    VDropdown
  },
  props: {
    helpText: {
      default: ""
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>
